export default __webpack_public_path__ + "static/media/Toatl.0cdf1fcc.svg";